<!--  -->
<template>

  <page pageDataUrl="/api/pageData/page_company"
        v-on:paddingData="paddingPageData"
        defPageTitle="公司简介"
        :hasbreadcrumbs="true">

    <div class='content'>
      <h1 class="entry-title">公司简介</h1>

      <div v-html="content"
           style="margin-bottom:20px"></div>

      <h1 class="history-title">服务团队</h1>
      <div class="company-info"
           v-for="(company ,index) in companys">
        <table class="company-left">
          <tr>
            <th class="info-title"
                valign="top">
              名称
            </th>
            <td class="info-content"
                valign="top">{{company.name}}</td>
          </tr>

          <tr v-for="(item,index) in company.infos">
            <th class="info-title"
                valign="top">
              {{item.key}}
            </th>
            <td class="info-content"
                valign="top">{{item.info}}</td>
          </tr>
        </table>

        <table class="company-right">
          <th class="info-title"
              valign="top">地址/联系方式</th>
          <td class="info-content"
              valign="top">
            <div>
              <p>
                {{company.address}}
              </p>
              <ul style="display: flex;flex-wrap: wrap;width:320px;">
                <li style="folat:left;margin:0 10px 0 0;"
                    v-for="(tell ,tIndex) in company.tells"><a style="color: #444;"
                     :href="'tel:'+tell.tell">{{tell.tell}}</a>({{tell.key}})</li>
              </ul>
              <p style="font-size:95%"><a :href="'mailto:'+company.email"
                   style="color: #0066CB;font-weight: 600;">{{company.email}}</a>（邮箱）</p>
              <p style="font-size:95%"><a :href="'mailto:'+company.hrEmail"
                   style="color: #0066CB;font-weight: 600;">{{company.hrEmail}}</a>（人事）</p>
            </div>
            <iframe :src="company.positionUrl"
                    v-if="company.positionUrl !== undefined"
                    style="margin-top: 20px; width: 442px;height: 240px;"></iframe>
          </td>
        </table>

      </div>
      <h1 class="history-title">历史</h1>

      <table class="history-table">
        <tr v-for="(item , index) in historys">
          <th valign="top">
            <p style="float: left;font-size:95%;font-weight: 700; ">{{item.historyDate.substring(0,5)}}</p>
            <p style="padding-left: 0.6em; padding-right: 0.6em;float: right;font-size:95%;font-weight: 700; ">
              {{item.historyDate.substring(5,8)}}</p>
          </th>
          <td valign="top">
            <p style="font-size:95%;font-weight: 400;">
              {{item.historyContent}}
            </p>
          </td>
        </tr>

      </table>

      <!-- <h1 class="history-title">营业额</h1>

      <table class="history-table">
        <tr>
          <th valign="top">
            <p style="float: left;">1948年</p>
            <p style="padding-left: 0.6em;padding-right: 0.6em;float: right;">6月期</p>
          </th>
          <td valign="top">
            10,089百万円（輸出額2,004百万円）
          </td>
        </tr>

        <tr>
          <th valign="top">
            <p style="float: left;">1948年</p>
            <p style="padding-left: 0.6em;padding-right: 0.6em;float: right;">6月期</p>
          </th>
          <td valign="top">
            10,089百万円（輸出額2,004百万円）
          </td>
        </tr>

        <tr>
          <th valign="top">
            <p style="float: left;">1948年</p>
            <p style="padding-left: 0.6em; padding-right: 0.6em;float: right;">6月期</p>
          </th>
          <td valign="top">
            10,089百万円（輸出額2,004百万円）
          </td>
        </tr>

      </table> -->

    </div>
  </page>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      historys: [],
      companys: [],
      content: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    paddingPageData(data) {
      if (data.data.companys !== undefined)
        for (var i = 0, len = data.data.companys.length; i < len; i++) {
          var company = data.data.companys[i];
          company.infos = JSON.parse(company.infos);
          company.tells = JSON.parse(company.tells);
        }
      this.content = data.data.content;
      this.companys = data.data.companys;
      this.historys = data.data.historys;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // var that = this;
    // this.$request.get({
    //   url: "/api/pageData/page_company",
    //   callback: {
    //     success: function (data) {
    //       // that.forewordDialogVisible = false;
    //     },
    //     err: function (err) {
    //       console.log(err);
    //     }
    //   }
    // });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
/* @import url('../../../assets/css/all.css');  */

.history-table {
  margin: 20px auto;
  width: calc(100% - 100px);
}

.history-table th {
  display: table-cell;
  width: 120px;
  background-color: #fff;
  border-right: #bbb 1px solid;
  font-size: 95%;
}

.history-table td {
  vertical-align: top;
  padding-right: 0;
  padding-left: 10px;
  padding-bottom: 15px;
  display: table-cell;
  font-size: 95%;
}

.history-title {
  font-size: 115%;
  letter-spacing: normal;
  text-align: left;
  padding: 8px 10px;
  background: #314478;
  margin-bottom: 30px;
  color: #fff;
}

.company-left {
  width: 37%;
}

.company-right {
  width: 58%;
}

.company-info {
  margin-bottom: 50px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 0 15px;
}

.company-info table {
  border: 0;
  margin: 0;
}

.company-info .info-title {
  background-color: #fff;
  border-right: #bbb 1px solid;
  width: 83px;
  display: table-cell;
  font-weight: 700;
}

.company-info .info-content {
  padding-right: 0;
  padding-left: 10px;
  padding-bottom: 15px;
  font-size: 95%;
  font-weight: 400;
}
</style>